<div class="banner_header">
  <div class="col-md-12">
      <h2> Payment Verified List </h2>
  </div>
</div>

<div class="download_section pad_btm_size">


  <div class="row" style="text-align: left;">
      <div class="col-md-12">

<h2>Search your Ticket Id or CC Reference Number</h2>
        <mat-form-field>
          <input matInput (change)="applyFilterView($event)" placeholder="Search">
      </mat-form-field>

      <!-- <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'test', sheet: 'sheet_name', Props: {Author: 'nimi'}})">Excel</button> -->

      <div class="example-container mat-elevation-z8" >
          <mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource_view" #t1Sort="matSort" matSort>

              <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="ticketId">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
              </ng-container>


              <!-- Name Column -->
              <ng-container matColumnDef="ccrefno">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ccrefno}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ccrefnostatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno status </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ccrefnostatus}} </mat-cell>
              </ng-container>



              <!-- Symbol Column -->
              <ng-container matColumnDef="admin_status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> status
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.admin_status}} </mat-cell>
              </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="admin_status_description">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Description
    </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.admin_status_description}} </mat-cell>
</ng-container>


              <!-- Symbol Column -->
              <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
                  <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                          (click)="report_view()">View</button>
                  </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns_view"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns_view;"></mat-row>

          </mat-table>
          <mat-paginator #t1Paginator="matPaginator" [length]="totallength" (page)="pageEvent = $event; pageChanged($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>


      </div>


      </div>
  </div>



<div *ngIf="pageEvent" style="display: none;">
    <h5>Page Change Event Properties</h5>
    <div>List length: {{pageEvent.length}}</div>
    <div>Page size: {{pageEvent.pageSize}}</div>
    <div>Page index: {{pageEvent.pageIndex}}</div>
</div>

</div>





